import React, { useState } from "react";
import "./Teaching.css";

const data = [
    {
        id: 1,
        title: "EDUCATION",
        content: [
            "Initial Training under Prof. Sanat Chatterjee, Father & Guru, an eminent artist of India.",
            "Post- Graduation in Fine Arts (Topper), Bahuguna University, Uttrakhand.1989",
            "M.Phil in Ancient History from HP University, Shimla, 1991 Dissertation: “The Architectural and Decorative Arts of Kinnaur”",
            "Doctorate on “Arts of Kinnaur” from Kurukshetra University.2003",
        ],
    },
    {
        id: 2,
        title: "ORIENTATION",
        content: [
            "Attended the orientation programme 1998, organized by Academic Staff College, H.P. University.",
        ],
    },
    {
        id: 3,
        title: "REFRESHER COURSES",
        content: [
            "Attended three weeks refresher course in computer and I.T. Awareness Programme 2000, in A.S.A-H.P.U.",
            "Three weeks refresher course in Fine Arts in A.S.A. Guru Nank Dave University.Amritsar, Dec2001.",
            "Three weeks refresher course in Fine Arts in A.S.A. Himachal Pradesh University, Shimla,June-2005.",      
        ],
    },
    {
        id: 4,
        title: "TEACHING EXPERIENCE",
        content:[
            "Taught as Assistant Professor of Fine Arts in College of Education, Kurukshetra University from 1990 to 1991.",
            "Visiting as Assistant Professor in the Department of Fine Arts, Kurukshetra University Jan, Feb 1996.",
            "Teaching in the Department of Visual Arts, P.G. Center, HP University, since Feb 1994.",
        ],
    },
    {
        id: 5,
        title: "RESEARCH",
        subContent: [
            {
                id: 1,
                title: "RESEARCH PROJECT",
                content: [
                    "Forts and Palaces of Himachal Pradesh: Fellowship from the UGC Center of Excellence, Integrated institute of Himalayan Studies, Shimla, 2005-06",
                    "Rural Houses of Himachal Pradesh: Fellowship from the UGC Center of Excellence, Integrated institute of Himalayan Studies, Shimla, 2007.",
                ],
            },
            {
                id: 2,
                title: "RESEARCH PUBLICATIONS",
                content: [
                    "“Art, Culture and Social Consciousness” -a research paper accepted in Guru Nank Journal of Sociology, Vol.33, No.1.2012",
                    "“The Mystic Matrix” -a research paper accepted in Artistic Narration- A journal of Visual and Performing Arts, 2012",
                    "“Tracing the Terracotta Tradition” -a research paper accepted in Art Family-a National Journal on Art and Aesthetics, 2012",
                    "“The Yantra Art” -a research paper accepted in HPU Journal for the next Issue 2012.",
                    "“Pagoda Temples of Kinnaur” a research paper accepted in ALTAI-Himalayas: Two Foundation of Eurasia- an International Monograph,- 2012",
                    "“kavita men kala ya kala men kavita- eak nai kogh Rabindranath Tagore” -a research paper published in Art Family-a National Journal on Art and Aesthetics, 2012",
                    "Saga of Himalayan Architecture: Pagoda Temples of Kinnaur” a research paper published in Russia, 2012",
                    "Traditional Residential Patterns in Rural Himachal-A Socio-Cultural, Artistic and Architectural Perspective’ chapter in book titled Vignettes of Himachal Himalayas vol -1 published by Satayam Publishing House, New Delhi 2013",
                ],
            },
            {
                id: 3,
                title: "RESEARCH SUPERVISION",
                content: [
                    "Supervised-150-dissertations on different subjects on Visual Arts done by the P.G. students of Department of Visual Arts, H.P.U.",
                    "Supervised 16 Ph.D",
                    "Supervising 5 Ph.D Scholars.",
                    "One D. Litt.",
                ],
            },
        ],
    },
    {
        id: 6,
        title: "BOOKS" ,
        content: [
            "“Forts and Palaces of Himachal Pradesh”, a coffee table book, co-author Usha Bande",
            "“A Journey from Inspiration to Expression on Canvas” an edited book",
            "“Expression” an edited book",
            "Emerging Trends in Art and Literature-Edited book- September 2020",
            "Recent Trends in Developmental Studies- Edited book- September 2020",
            "History of Indian Art..co authored, text book for CBSE-February 21",
        ],
     },
     {
        id: 7,
        title: "INVITED LECTURES",
        content: [
            "RUSA Value Added Course series of lectures on Indian Art online from 25th March to 8th April 2023 organized by Punjab University Management department.",
            "Visiting resource person in all orientation programmes conducted in the Academic Staff College (ASC), HP University for University and College teachers of India.",
            "Visiting Resource person for National Institute of Fashion Technologies, NIFT",
            "Visiting resource person to deliver lectures to the officers trainee, of all batches of the Indian Audit and Accounts Services at National Academy of Audit and Accounts, Shimla",
            "Invited as a resource person to deliver five lectures in a series on Art and Aesthetics to the directors, in the Theater Directors Workshop, Organized by National School of Drama, Ministry of Culture, Government of India from 1st to 5th Dec, 2014.",
            "Invited as a resource person to deliver lectures on visual arts to all the Art teachers of North India from different Novedeya Schools under the Ministry of Human Resources, Government of India, Oct.2014.",
            "Invited as a Resource person in the Academic Staff College (ASC), Guru Nank dev University, Amritsar for Refresher Course in Fine Arts, Dec, 2012",
            "Invited as a key speaker on Tagore 150th celebration at Dharmshala by Academy of Language Art and culture, H.P. Dec 2012",
            "Regular Resource person in the Directorate of Education of Himachal Government for in service Drawing Teachers refresher course programmes",
            "Invitation to deliver lectures on Aesthetics and Architecture from Indian Institute of Technology (IIT), Mandi.",
            "Lecture cum demonstration and conducted a workshop of painting for C.E.O of different countries of Cadbury International Ltd at Wild Flower Hall, Mashobra- Shimla.",
            "Lecture on “Aesthetics and Structures’ to the IES probationers at C.P.W.D. training Institute, Gaziabad, U.P.2005.",
            "Lecture on Appreciation of Art to the IAAS probationers and faculty members of National audit and Account Services, Shimla Aug-2002,2003.",
            "Lecture on Creative Photography to the IAAS probationers and faculty members of National audit and Account Services, Shimla Aug-2002,2003.",
            "Lecture on Art- Its Appreciation, to the Army Officers, Organized by A.R.T.R.A.C., Sep-1995",
        ],
     },
];

    function Teaching() {
       const [activeId, setActiveId] = useState(1); // By default pehla show hoga
           const [activeSubId, setActiveSubId] = useState(null);
       
           const handleClick = (id) => {
               setActiveId(id);
               setActiveSubId(null); // Jab main heading change ho to subheading reset ho jaye
           };
       
           const handleSubClick = (id) => {
               setActiveSubId(id);
           };
       
       
           return (
               <div className="advisor-container">
                   <div className="advisor-left">
                       {data.map((item) => (
                           <div
                               key={item.id}
                               className={`advisor-title ${activeId === item.id ? "active" : ""}`}
                               onClick={() => handleClick(item.id)}
                           >
                               {item.title}
                           </div>
                       ))}
                   </div>
       
                   <div className="advisor-right">
                       {data
                           .filter((item) => item.id === activeId)
                           .map((item) => (
                               <div key={item.id} className="advisor-content-container">
                                   {/* Agar normal content ho */}
                                   {item.content && (
                                       <ul className="advisor-content">
                                           {item.content.map((line, index) =>
                                               line.startsWith("*") ? (
                                                   <li key={index} className="advisor-heading">
                                                       {line.replace(/^\*/, "")}
                                                   </li>
                                               ) : (
                                                   <li key={index}>{line}</li>
                                               )
                                           )}
                                       </ul>
                                   )}
       
                                   {/* Agar subContent ho */}
                                   {item.subContent &&
                                       item.subContent.map((sub) => (
                                           <div key={sub.id} className="sub-content-section">
                                               <div
                                                   className={`sub-title ${activeSubId === sub.id ? "active-sub" : ""
                                                       }`}
                                                   onClick={() => handleSubClick(sub.id)}
                                               >
                                                   {sub.title}
                                               </div>
                                               {activeSubId === sub.id && (
                                                   <ul className="sub-content-list">
                                                       {sub.content.map((line, idx) =>
                                                           line.startsWith("*") ? (
                                                               <li key={idx} className="advisor-heading">
                                                                   {line.replace(/^\*/, "")}
                                                               </li>
                                                           ) : (
                                                               <li key={idx}>{line}</li>
                                                           )
                                                       )}
                                                   </ul>
                                               )}
                                           </div>
                                       ))}
                               </div>
                           ))}
                   </div>
               </div>
           );
    }

export default Teaching;